import { Helmet } from 'react-helmet-async';

function SEO({ title, description, canonical }) {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Boldly English",
    "url": "https://boldlyenglish.com/",
    "logo": "https://boldlyenglish.com/logo192.png",
    "description":
      "Boldly English helps learners improve their English speaking, communication, vocabulary, and confidence."
  };

  return (
    <Helmet>
      {/* Page Title */}
      <title>{title}</title>

      {/* Meta Description */}
      <meta
        name="description"
        content={description}
      />

      {/* Canonical URL */}
      <link
        rel="canonical"
        href={canonical}
      />

      {/* Open Graph - Facebook, WhatsApp, LinkedIn */}
      <meta
        property="og:title"
        content={title}
      />

      <meta
        property="og:description"
        content={description}
      />

      <meta
        property="og:type"
        content="website"
      />

      <meta
        property="og:url"
        content={canonical}
      />

      <meta
        property="og:image"
        content="https://boldlyenglish.com/logo192.png"
      />

      <meta
        property="og:site_name"
        content="Boldly English"
      />

      {/* Twitter / X */}
      <meta
        name="twitter:card"
        content="summary_large_image"
      />

      <meta
        name="twitter:title"
        content={title}
      />

      <meta
        name="twitter:description"
        content={description}
      />

      <meta
        name="twitter:image"
        content="https://boldlyenglish.com/logo192.png"
      />

      {/* Structured Data - Organization */}
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
}

export default SEO;